import { api } from '@/api';

export interface ReportData {
  categories: Record<
    string,
    {
      amount: number;
      percentOnTotal: number;
      transactions: Array<{ id: string }>;
    }
  >;
  diffs?: {
    totalAmount?: number;
    totalTransactions?: number;
    avgTransactionAmount?: number;
  };
}

/**
 * Service for reports API operations
 */
class ReportsApiService {
  /**
   * Get a report by ID
   */
  async getReport(reportId: string) {
    return api.v1.reports({ id: reportId }).get();
  }

  async getCategoryReport(
    categoryId: string,
    dateFrom: string,
    dateTo: string
  ) {
    return api.v1.reports.category({ categoryId }).get({
      query: { dateFrom, dateTo },
    });
  }
}

export const reportsApiService = new ReportsApiService();
